/**
 * Wagamour V2 foundation primitives — shared by UpgradeModal and V2-skinned surfaces.
 */

export {
  WagamourV2Surface,
  type WagamourV2SurfaceProps,
} from '@/components/v2/WagamourV2Surface'
export {
  WagamourV2Button,
  type WagamourV2ButtonProps,
  type WagamourV2ButtonPropsWithSize,
  type WagamourV2ButtonSize,
} from '@/components/v2/WagamourV2Button'
export {
  WagamourV2Modal,
  type WagamourV2ModalProps,
} from '@/components/v2/WagamourV2Modal'
export {
  WagamourV2ModalEyebrow,
  WagamourV2ModalHeadline,
  WagamourV2ModalStoryLine,
  WagamourV2ModalNestedCard,
  WagamourV2ModalFieldLabel,
  WagamourV2ModalIconWell,
  WagamourV2ModalInput,
  WagamourV2ModalTextarea,
  WagamourV2ModalSelect,
  WagamourV2ModalChipToggle,
} from '@/components/v2/WagamourV2ModalContent'
export {
  FormFieldLabel,
  FormFieldRequiredMark,
  FormFieldError,
  FormErrorBanner,
} from '@/components/v2/FormField'
